// Generated by ts-to-zod
import {z} from "zod";

const mantineFloatingPositionSchema = z.any();

export const mantineMenuPropsSchema = z.strictObject({
	shadow: z.string().optional(),
	position: mantineFloatingPositionSchema.optional(),
});
